var map = {
	"./aa-nirf.jpeg": 31535,
	"./aa-ogvision.jpeg": 79928,
	"./aa-oterflow.jpeg": 86530,
	"./aa-rvjcse.png": 30188,
	"./aa-sihmca.jpeg": 32777,
	"./aa-summitmca.png": 49455,
	"./aa-xenovaxctug.png": 65705,
	"./aaa-alumni-neha.jpeg": 4580,
	"./aaa-civil&ai.jpeg": 36652,
	"./aaa-it.jpeg": 97284,
	"./aaa-mtsbanraw.png": 15395,
	"./aaaa.png": 49024,
	"./aaaaa.png": 28699,
	"./aaaaaa.png": 85274,
	"./aaaaaaa.png": 95769,
	"./aaaaaaaa-mts.png": 15113,
	"./aaaaaaaaa-aeromodelling.jpeg": 5823,
	"./aaaaaaaaa-chem.jpeg": 51406,
	"./aaaaaaaaa-chemical.png": 29030,
	"./aaaaaaaaa-cit.jpeg": 2905,
	"./aaaaaaaaa-genai.jpeg": 56701,
	"./aaaaaaaaaa-chemical.png": 33569,
	"./aaaaaaaaaa.png": 58878,
	"./ab-cse.png": 92245,
	"./ac-cse.png": 92008,
	"./ad-it.png": 98165,
	"./ae-eie.png": 28834,
	"./af-mechatronics.png": 88360,
	"./ag-tbi_20thanniversary.jpg": 90517,
	"./agg-placement status2025.png": 96704,
	"./agg-placement status2025december.png": 55349,
	"./aggg-accenture.jpeg": 86894,
	"./aggg-cts.jpeg": 7198,
	"./aggg-cts2.jpeg": 23872,
	"./aggg-rubrick.png": 559,
	"./aggggg-enworx.png": 76466,
	"./agggggg-zoho.png": 18202,
	"./aggggggg-zoho2.png": 57809,
	"./agggggggg-zoho-traine.png": 54456,
	"./ahhh-josh.png": 43590,
	"./ahhhh-securin.png": 45107,
	"./ahhhhh.png": 27095,
	"./ahhhhhh.png": 95007,
	"./ahhhhhhh.png": 28263,
	"./ahhhhhhhh.png": 97967,
	"./ahhhhhhhhh.png": 49271,
	"./ahhhhhhhhhh.png": 18015,
	"./ahhhhhhhhhhh.png": 68455,
	"./ahhhhhhhhhhhh.png": 11823,
	"./ahhhhhhhhhhhhh.png": 27927,
	"./ahhhhhhhhhhhhhh.png": 80607,
	"./ahhhhhhhhhhhhhhh.png": 45863,
	"./ahhhhhhhhhhhhhhhh.png": 54255,
	"./ahhhhhhhhhhhhhhhhh.png": 26007,
	"./ai-rapiddata.png": 93619,
	"./aii-rapiddata.png": 58880,
	"./aiii-rapiddata.png": 82937,
	"./aiiii.png": 87483,
	"./aiiiii.png": 49906,
	"./aiiiiii.png": 92377,
	"./aiiiiiii.png": 93004,
	"./aiiiiiiii.png": 76023,
	"./aiiiiiiiii.png": 18550,
	"./aiiiiiiiiii.png": 48741,
	"./aiiiiiiiiiii.png": 84864,
	"./aiiiiiiiiiiii.png": 8035,
	"./aj.png": 31749,
	"./ajj.png": 14011,
	"./ajjj.png": 55977,
	"./ajjjj.png": 51511,
	"./ajjjjj.png": 76301,
	"./ajjjjjj.png": 10275,
	"./ajjjjjjj.png": 21905,
	"./ajjjjjjjj.png": 76671,
	"./ajjjjjjjjj.png": 41333,
	"./ajjjjjjjjjj.png": 68939,
	"./ajjjjjjjjjjj.png": 56985,
	"./ajjjjjjjjjjjj.png": 63783,
	"./ak.jpeg": 93233,
	"./akk.jpeg": 43130,
	"./akkk.jpeg": 57555,
	"./akkkk.jpeg": 45276,
	"./akkkkk.png": 18368,
	"./akkkkkk.png": 86865,
	"./akkkkkkkk.png": 97783,
	"./akkkkkkkkk.png": 7684,
	"./akkkkkkkkkk.png": 22429,
	"./akkkkkkkkkkk.png": 21034,
	"./akkkkkkkkkkkk.png": 43299,
	"./akkkkkkkkkkkkk.png": 57928,
	"./akkkkkkkkkkkkkk.png": 92889,
	"./akkkkkkkkkkkkkkk.png": 70718,
	"./al.png": 2291,
	"./all.png": 89815,
	"./alll.png": 411,
	"./allll.png": 22559,
	"./alllll.png": 1699,
	"./allllll.png": 95719,
	"./alllllll.png": 96715,
	"./allllllll.png": 30351,
	"./alllllllll.png": 66739,
	"./allllllllll.png": 60663,
	"./alllllllllll.png": 68187,
	"./allllllllllll.png": 44639,
	"./alllllllllllll.png": 68291,
	"./allllllllllllll.png": 6983,
	"./alllllllllllllll.png": 80075,
	"./allllllllllllllll.png": 6095,
	"./alllllllllllllllll.png": 27315,
	"./am.png": 63434,
	"./amm.png": 82645,
	"./ammm.png": 45844,
	"./ammmm.png": 36571,
	"./ammmmm.png": 70006,
	"./ammmmmm.png": 41057,
	"./ammmmmmm.png": 54096,
	"./ammmmmmmm.png": 73143,
	"./ammmmmmmmm.png": 70770,
	"./ammmmmmmmmm.png": 59101,
	"./ammmmmmmmmmm.png": 64668,
	"./ammmmmmmmmmmm.png": 45731,
	"./ammmmmmmmmmmmm.png": 66558,
	"./ammmmmmmmmmmmmm.png": 8649,
	"./an-amul.png": 32177,
	"./an-aypols.png": 25994,
	"./an-bagwancybertec.png": 37177,
	"./an-bigboon.png": 10902,
	"./an-brakeindia.png": 36974,
	"./an-brakesindia.png": 5783,
	"./an-cognizant.png": 76409,
	"./an-cognizant2.png": 53519,
	"./an-croptob.png": 64143,
	"./an-crprobotics.png": 98484,
	"./an-datapattern.png": 90020,
	"./an-deloitte.png": 11568,
	"./an-delta.png": 56588,
	"./an-gecatech.png": 18036,
	"./an-harmony.png": 86572,
	"./an-ibm.png": 77320,
	"./an-infosys.png": 57933,
	"./an-jsw.png": 98074,
	"./an-jsw2.png": 69106,
	"./an-manis.png": 18022,
	"./an-mithilai.png": 15151,
	"./an-motherson.png": 28349,
	"./an-netgear.png": 69134,
	"./an-pothigai.png": 26349,
	"./an-rane.png": 35844,
	"./an-slb.png": 28695,
	"./an-soliton.png": 86024,
	"./an-spic.png": 26721,
	"./an-srinsoft.png": 23446,
	"./an-tvs.png": 6563,
	"./an-valeo.png": 2363,
	"./an-virtusa.png": 61720,
	"./an-wabag1.png": 72447,
	"./an-wabag2.png": 87172,
	"./an-wabag3.png": 50413,
	"./an.png": 12417,
	"./ao-amul.png": 48486,
	"./ao-craftsman.png": 9784,
	"./ao-hcl.png": 73178,
	"./ao-hdfc.png": 45890,
	"./ao-kapitus.png": 87292,
	"./ao-pinnacle.png": 71571,
	"./ao-propel.png": 19167,
	"./ao-sakthiauto.png": 72894,
	"./ao-southernauto.png": 82446,
	"./ao-tuticorinalkali.png": 72700,
	"./bd-naac_2022.jpg": 86461,
	"./be-tbi_kec_2024.jpg": 74902,
	"./bf-conventioncentre.jpg": 51243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92770;